module.exports = __webpack_public_path__ + "img/house.4b49a2f3.svg";